module.exports = __webpack_public_path__ + "static/media/instagram.8510a37d.svg";